import { FC } from "react";
import cn from "classnames";

const DefaultSpinner: FC<{ className?: string }> = ({ className }) =>
  <div className={cn("default-spinner", className)} />;

export default DefaultSpinner;
